import BillingItemsList from '../util/billing_items_list'

up.compiler('[billing-items-list]', (element) => {
  const form = element.closest('form')
  const billingItemsList = new BillingItemsList()

  form.addEventListener('submit', function(event) {
    if (!billingItemsList.isValid()) {
      event.preventDefault()
    }
  })

  up.on(element, 'app:billing-item:created', function(event) {
    billingItemsList.addBillingItem(event.target.billingItem)
  })
})
